module.exports = __webpack_public_path__ + "img/app-store-en.d3123f9.png";